import { useCallback, useEffect, useState } from 'react';
import { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { fetchUserInfo, fetchWorkersManagers } from '../../ExpertManagementPage/api';

export const useFetchWorkersManagers = (
  canRun: boolean = false,
  workerIds: string[],
  managerId?: string,
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [workerManagers, setWorkerManagers] = useState<Record<string, any>>({});
  const [managerEmail, setManagerEmail] = useState<string>(managerId ?? '');

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await fetchWorkersManagers(workerIds);
      setWorkerManagers(result.workerManagers);
      setLoading(false);
    } catch (e) {
      defaultApiFetchErrorHandler(e, { handleHttp: true });
    }

    setLoading(false);
  }, [workerIds]);

  useEffect(() => {
    if (!workerIds.length || !canRun) return;
    fetch();
  }, [workerIds, canRun, fetch]);

  useEffect(() => {
    if (!managerId || !canRun) return;
    try {
      (async () => {
        const result = await fetchUserInfo(managerId);
        if (result) setManagerEmail(result.email);
      })();
    } catch (e) {
      defaultApiFetchErrorHandler({
        name: 'error',
        message: e.message.error,
        logError: () => null,
      });
    }
  }, [managerId, canRun]);

  return {
    loading,
    workerManagers,
    managerEmail,
  };
};
